import type {PermissionsRecordType} from '../permissions';

export const saleVehiclePermissions = {
  saleVehicleBackgroundRemoval: {
    resourceId: 'SALE_VEHICLE_PHOTO_ALBUM',
    actionId: 'REMOVE_PHOTOS_BACKGROUND',
    scopes: [],
  },
  readPhotoCheckerReport: {
    resourceId: 'PHOTO_CHECKER_REPORT',
    actionId: 'READ',
    scopes: [],
  },
  createPhotoCheckerReport: {
    resourceId: 'PHOTO_CHECKER_REPORT',
    actionId: 'CREATE',
    scopes: [],
  },
  readAutotracerPl: {
    resourceId: 'AUTOTRACER_PL',
    actionId: 'READ',
    scopes: [],
  },
  createAutotracerPl: {
    resourceId: 'AUTOTRACER_PL',
    actionId: 'CREATE',
    scopes: [],
  },
  saleVehicleFinancingRead: {
    resourceId: 'SALE_VEHICLE_FINANCING',
    actionId: 'READ',
    scopes: [],
  },
  saleVehicleFinancingCreate: {
    resourceId: 'SALE_VEHICLE_FINANCING',
    actionId: 'CREATE',
    scopes: [],
  },
  saleVehicleFinancingUpdate: {
    resourceId: 'SALE_VEHICLE_FINANCING',
    actionId: 'UPDATE',
    scopes: [],
  },
  saleVehicleFinancingDelete: {
    resourceId: 'SALE_VEHICLE_FINANCING',
    actionId: 'DELETE',
    scopes: [],
  },
  saleVehicleLeasingRead: {
    resourceId: 'SALE_VEHICLE_LEASING',
    actionId: 'READ',
    scopes: [],
  },
  saleVehicleLeasingCreate: {
    resourceId: 'SALE_VEHICLE_LEASING',
    actionId: 'CREATE',
    scopes: [],
  },
  saleVehicleLeasingUpdate: {
    resourceId: 'SALE_VEHICLE_LEASING',
    actionId: 'UPDATE',
    scopes: [],
  },
  saleVehicleLeasingDelete: {
    resourceId: 'SALE_VEHICLE_LEASING',
    actionId: 'DELETE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
